var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 18.5C16.2614 18.5 18.5 16.2614 18.5 13.5C18.5 10.7386 16.2614 8.5 13.5 8.5C10.7386 8.5 8.5 10.7386 8.5 13.5C8.5 16.2614 10.7386 18.5 13.5 18.5ZM13.5 20C17.0899 20 20 17.0899 20 13.5C20 9.91015 17.0899 7 13.5 7C9.91015 7 7 9.91015 7 13.5C7 17.0899 9.91015 20 13.5 20Z",
    fill: "#5F6272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4697 17.4697C17.7626 17.1768 18.2374 17.1768 18.5303 17.4697L23.5303 22.4697C23.8232 22.7626 23.8232 23.2374 23.5303 23.5303C23.2374 23.8232 22.7626 23.8232 22.4697 23.5303L17.4697 18.5303C17.1768 18.2374 17.1768 17.7626 17.4697 17.4697Z",
    fill: "#5F6272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnify);
export default __webpack_public_path__ + "static/media/magnify.2a20d5de30755f3278b9b1f453653950.svg";
export { ForwardRef as ReactComponent };